/**
 * Coquille de l'application (design system, FenetreApp) : barre latérale, barre d'outils
 * avec le titre de l'écran, zone principale qui seule défile.
 */
import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { cx } from './outils';

const ContexteLaterale = createContext<ReactNode>(null);
export const FournisseurLaterale = ContexteLaterale.Provider;

export interface CoquilleProps {
  /** Titre de l'écran dans la barre d'outils (aussi titre du document). */
  titre: string;
  /** Contenu du titre s'il diffère du texte (fil d'Ariane). */
  titreAffiche?: ReactNode;
  actions?: ReactNode;
  colonne?: 'carte' | 'formulaire' | 'large';
  /** Bandeau collé en haut de la zone principale (connexion perdue…). */
  bandeau?: ReactNode;
  children: ReactNode;
}

export function Coquille({
  titre,
  titreAffiche,
  actions,
  colonne = 'carte',
  bandeau,
  children,
}: CoquilleProps) {
  const laterale = useContext(ContexteLaterale);
  useEffect(() => {
    document.title = `${titre} — Flashcard`;
  }, [titre]);
  return (
    <div className="fc-fenetre">
      <div className="fc-fenetre__laterale">
        <div className="fc-fenetre__poignee-laterale" />
        {laterale}
      </div>
      <header className="fc-fenetre__outils">
        <h1 className="fc-fenetre__titre">{titreAffiche ?? titre}</h1>
        {actions && <div className="fc-fenetre__actions">{actions}</div>}
      </header>
      <main className="fc-fenetre__principale">
        {bandeau}
        <div
          className={cx(
            'fc-fenetre__colonne',
            colonne !== 'carte' && `fc-fenetre__colonne--${colonne}`,
          )}
        >
          {children}
        </div>
      </main>
    </div>
  );
}
